const { CATEGORIES } = require('./site');

const _categories = CATEGORIES.map(c => c.as.replace('/', ''));
// prettier-ignore
module.exports = {
  ABOUT_REGEX: /\/about(?:\/|$)/,
  ARCHIVE_REGEX: /\/archive(?:\/|$)/,
  AUTHOR_REGEX: /^\/authors\/(.*[^/])/,
  POST_REGEX: /^\/[^/?#]*-(\d+)(?:[?#].*)?$/,
  // Old video page routes - these 301 to the JW hub, however the regex is still
  // necessary since we want to show a custom icon on teasers
  VIDEO_ID_REGEX: /^[^?#]*video:(\w{8})(?:[?#].*)?$/,
  VIDEO_URL_REGEX: /^https?:\/\/video\.apartmenttherapy\.com\/((m|p)\/.+)?$/,
  CATEGORY_REGEX: new RegExp(`^\/(${_categories.join('|')})$`),
  COLLECTION_REGEX: new RegExp(`^\/(?:collection|${_categories.join('|')})\/(.*[^/])`),
  SEARCH_REGEX: /^\/search(?:\/|$)/,
  YOUTUBE_REGEX: /^(?:[a-z]+:)?\/\/(.*)youtube\.com/,
  PRISM_REGEX: /^\/image\//,
  IMAGE_COLLECTION_REGEX: /^\/image\/collection/,
  FEATURES_REGEX: /^\/features\//,
  HOMEMADE_REGEX: /^\/homemade\//,
  FAQ_REGEX: /^\/faq\//,
  SMALL_COOL_EXPERIENCE_REGEX: /^\/small-cool-experience\//,
  CONTESTS_REGEX: /^\/contests\//,
  SUBMISSIONS_REGEX: /^\/submissions\//,
  AUTH_REGEX: /^\/(auth|sign-in|logout)(?:\/|$)/
};
